var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{staticClass:"doc-icon",class:[
    _vm.iconName ? `doc-icon_${_vm.iconName}` : '',
    _vm.iconTheme ? `doc-icon_theme-${_vm.iconTheme}` : '',
    _vm.iconSize ? `doc-icon_size-${_vm.iconSize}` : '',
  ]})
}
var staticRenderFns = []

export { render, staticRenderFns }